import { animated, useSpring } from "@react-spring/web";
import Headshot from "../../images/headshot.jpeg";
import "../../styles/Navigation.css";

const MobileNavigation = ({ navOpen, closeNav }) => {
  const anim = useSpring({
    translateX: navOpen ? "0%" : "-100%",
  });

  return (
    <animated.nav className="nav mobile__nav" style={anim}>
      <button onClick={closeNav} className="mobile__nav-close">
        <i className="fa-solid fa-x"></i>
      </button>
      <div className="nav__logo">
        <p>Jarrod</p>
      </div>
      <div className="nav__image">
        <div className="nav__image-container">
          <img
            src={Headshot}
            alt="me"
            className="nav__image-container--image"
          />
        </div>
      </div>
      <ul className="nav__links">
        <a href="#home" onClick={closeNav}>
          <li>
            <span>
              <i className="fa-solid fa-house"></i>
            </span>
            Home
          </li>
        </a>
        <a href="#about" onClick={closeNav}>
          <li>
            <span>
              <i className="fa-regular fa-address-card"></i>
            </span>
            About Me
          </li>
        </a>
        <a href="#technologies" onClick={closeNav}>
          <li>
            <span>
              <i className="fa-solid fa-sliders"></i>
            </span>
            Skills
          </li>
        </a>
        <a href="#projects" onClick={closeNav}>
          <li>
            <span>
              <i className="fa-solid fa-briefcase"></i>
            </span>
            Projects
          </li>
        </a>
        <a href="#contact" onClick={closeNav}>
          <li>
            <span>
              <i className="fa-regular fa-map"></i>
            </span>
            Contact
          </li>
        </a>
      </ul>
      <div className="nav__socials">
        <a href="https://github.com/gillijar" target="_blank" rel="noreferrer">
          <i className="fa-brands fa-github"></i>
        </a>
        <a
          href="https://www.linkedin.com/in/jarrod-gilliland/"
          target="_blank"
          rel="noreferrer"
        >
          <i className="fa-brands fa-linkedin"></i>
        </a>
      </div>
    </animated.nav>
  );
};

export default MobileNavigation;
